'use client';

import React from 'react';
import Image from 'next/image';
import { Box, Text } from '@ui-library';

import { NavLink } from '../../navigation/Navigation';
import { Section } from '@/models';
import { GUEST_PORTAL_IMAGE_QUALITY } from '@/constants/images';

type SectionImageProps = {
  section: Pick<Section, 'plain_text' | 'settings'>;
  company?: string;
  guestBookSlug?: string;
  isKioskMode?: boolean;
};

export const SectionImage = ({
  section,
  company,
  guestBookSlug,
  isKioskMode,
}: SectionImageProps) => {
  if (!section.settings.image_url) {
    return null;
  }

  const imageHeight = section.settings.image_height
    ? `${section.settings.image_height}px`
    : '250px';

  const ImageContent = () => (
    <Box>
      <Box position="relative" maxWidth="100%" height={imageHeight}>
        <Image
          src={section.settings.image_url as string}
          alt={(section.plain_text as string) || 'Section image'}
          fill
          sizes="(max-width: 768px) 100vw, 420px"
          style={{
            objectFit: 'contain',
            objectPosition: 'center',
          }}
          quality={GUEST_PORTAL_IMAGE_QUALITY}
        />
      </Box>
      {Boolean(section.plain_text) && (
        <Box mt="2" textAlign="center">
          <Text fontSize="sm" color="gray.700">
            {section.plain_text}
          </Text>
        </Box>
      )}
    </Box>
  );

  // if link is configured, wrap with NavLink
  if (section.settings.value && section.settings.type) {
    return (
      <NavLink
        block={section}
        company={company}
        guestBookSlug={guestBookSlug}
        isKioskMode={isKioskMode}
      >
        <ImageContent />
      </NavLink>
    );
  }

  return <ImageContent />;
};
